import { dateToSeconds } from '@/lib/util/dateTime';
import { editBreakState } from '@/lib/breaks/editBreakState';

export function replaceBreak(state: any, intEnd: number, intStart: number) {
  const currentBreakSlot = state.breaks[editBreakState.breakId];

  state.breaks[editBreakState.breakId] = {
    blnEmptySlot: currentBreakSlot.blnEmptySlot,
    intEnd: intEnd,
    intStart: intStart,
    intUnixEnd: dateToSeconds(
      state.break.endDate.getFullYear(),
      state.break.endDate.getMonth() + 1,
      state.break.endDate.getDate(),
      state.break.endTime.data.HH,
      state.break.endTime.data.mm
    ),
    intUnixStart: dateToSeconds(
      state.break.startDate.getFullYear(),
      state.break.startDate.getMonth() + 1,
      state.break.startDate.getDate(),
      state.break.startTime.data.HH,
      state.break.startTime.data.mm
    ),
    mixedActivity: currentBreakSlot.mixedActivity,
    strState: currentBreakSlot.strState,
    strType: currentBreakSlot.strType,
    strTypeName: currentBreakSlot.strTypeName,
  };

  return state.breaks;
}
